import React, { useState, useRef, useEffect } from 'react';

import uploadService from '../../api/fileUpload';



const AddProjectModal = ({ show, onHide, onAdd, onEdit, editData, defaultImg }) => {

  const fileInputRef = useRef(null);

  const [previewImage, setPreviewImage] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [isUploading, setIsUploading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(""); // UI Error State



  const [project, setProject] = useState({
  title: '', 
  category: '', 
  location: '', 
  budget: '', 
  status: 'Pending', 
  img: null,
  isActive: true   // <-- default value
});



  useEffect(() => {

    if (editData) {

      setProject(editData);

      setPreviewImage(editData.img);

    } else {

      setProject({ title: '', category: '', location: '', budget: '', status: 'Pending', img: null });

      setPreviewImage(null);

    }

    setSelectedFile(null);

    setErrorMessage(""); // Clear errors on toggle

  }, [editData, show]);



  if (!show) return null;



  const handleImageChange = (e) => {

    const file = e.target.files[0];

    if (file) {

      setSelectedFile(file);

      setPreviewImage(URL.createObjectURL(file));

    }

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setIsUploading(true);

    setErrorMessage("");



    try {

      let finalImgUrl = project.img;



      // 1. Handle File Upload

      if (selectedFile) {

        const uploadResponse = await uploadService.uploadFile('projects', selectedFile);

       

        // Based on your console log: the path is uploadResponse.data.fullUrl

        if (uploadResponse.success && uploadResponse.data && uploadResponse.data.fullUrl) {

          finalImgUrl = uploadResponse.data.fullUrl;

        } else {

          throw new Error("Upload succeeded but image URL was not received.");

        }

      }



      // 2. Validate Image existence before sending to Backend

      if (!finalImgUrl && !defaultImg) {

        throw new Error("Please upload an image or provide a default.");

      }



      // 3. Prepare Final Data

      const finalData = {

        ...project,

        img: finalImgUrl || defaultImg,

        // Convert budget to number if it's a string, as your Mongoose schema expects a Number

        budget: project.budget ? Number(project.budget) : null

      };



      // 4. Send to Parent (Project.jsx)

      if (editData && typeof onEdit === 'function') {

        await onEdit(finalData);

      } else if (typeof onAdd === 'function') {

        await onAdd(finalData);

      } else {

        throw new Error("Action handler missing");

      }



      onHide();

    } catch (error) {

      // Show descriptive error message in the red box

      const errorMsg = error.response?.data?.error || error.message || "Failed to process project.";

      setErrorMessage(errorMsg);

      setTimeout(() => setErrorMessage(""), 5000);

    } finally {

      setIsUploading(false);

    }

  };



  return (

    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>

      <div className="modal-dialog modal-md modal-dialog-centered">

        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>

         

          {/* INLINE ERROR MESSAGE - Replaces Alerts */}

          {errorMessage && (

            <div className="position-absolute w-100 px-4" style={{ top: '10px', zIndex: 1100 }}>

              <div className="alert alert-danger shadow-sm border-0 py-2 small d-flex align-items-center">

                <i className="bi bi-exclamation-triangle-fill me-2"></i>

                {errorMessage}

              </div>

            </div>

          )}



          <div className="modal-header border-0 pt-4 px-4">

            <div>

              <h5 className="fw-bold mb-0">{editData ? 'Edit Project' : 'Create New Project'}</h5>

              <small className="text-muted">Update infrastructure details.</small>

            </div>

            <button type="button" className="btn-close" onClick={onHide} disabled={isUploading}></button>

          </div>

         

          <form onSubmit={handleSubmit}>

            <div className="modal-body px-4 py-3">

              <div className="mb-4 text-center">

                <div

                  className="mx-auto mb-2 border d-flex align-items-center justify-content-center overflow-hidden"

                  style={{ width: '100%', height: '160px', borderRadius: '12px', backgroundColor: '#f8f9fa', cursor: 'pointer', borderStyle: 'dashed' }}

                  onClick={() => !isUploading && fileInputRef.current.click()}

                >

                  {previewImage ? (

                    <img src={previewImage} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

                  ) : (

                    <div className="text-muted text-center">

                      <i className="bi bi-cloud-arrow-up fs-1 d-block"></i>

                      <span className="small fw-bold">Upload project cover</span>

                    </div>

                  )}

                </div>

                <input type="file" ref={fileInputRef} hidden accept="image/*" onChange={handleImageChange} />

              </div>



              <div className="mb-3">

                <label className="form-label small fw-bold text-muted">PROJECT TITLE</label>

                <input

                  type="text" className="form-control" required

                  disabled={isUploading}

                  value={project.title}

                  onChange={(e) => setProject({...project, title: e.target.value})}

                />

              </div>



              <div className="row">

                <div className="col-md-6 mb-3">

                  <label className="form-label small fw-bold text-muted">CATEGORY</label>

                  <input

                    type="text" className="form-control" required

                    disabled={isUploading}

                    value={project.category}

                    onChange={(e) => setProject({...project, category: e.target.value})}

                  />

                </div>

                <div className="col-md-6 mb-3">

                  <label className="form-label small fw-bold text-muted">BUDGET</label>

                  <input

                    type="text" className="form-control"

                    disabled={isUploading}

                    value={project.budget}

                    onChange={(e) => setProject({...project, budget: e.target.value})}

                  />

                </div>

              </div>



              <div className="mb-2">

                <label className="form-label small fw-bold text-muted">LOCATION</label>

                <input

                  type="text" className="form-control"

                  disabled={isUploading}

                  value={project.location}

                  onChange={(e) => setProject({...project, location: e.target.value})}

                />

              </div>

              <div className="mb-3">
                <label className="form-label small fw-bold text-muted">ACTIVE STATUS</label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={project.isActive}
                    disabled={isUploading}
                    onChange={(e) => setProject({ ...project, isActive: e.target.checked })}
                  />
                  <label className="form-check-label">
                    {project.isActive ? 'Active' : 'Inactive'}
                  </label>
                </div>
              </div>


            </div>



            <div className="modal-footer border-0 pb-4 px-4 pt-0">

              <button type="button" className="btn btn-light px-4 fw-bold text-muted border-0" onClick={onHide} disabled={isUploading}>Discard</button>

              <button type="submit" className="btn btn-primary px-5 fw-bold shadow-sm" disabled={isUploading}>

                {isUploading ? <span className="spinner-border spinner-border-sm"></span> : (editData ? 'Update' : 'Save')}

              </button>

            </div>

          </form>

        </div>

      </div>

    </div>

  );

};



export default AddProjectModal; 